<div class="filter-holder">
  <span class="title">SAMTYCKE FRÅN:</span>
  <span class="model-name">
      <mat-icon class="account-circle">account_circle</mat-icon>
    {{ consent.modelName }}
    </span>

  <div class="information-holder">
    <label for="modelSub">MODELL PERSONNUMMER:</label>
    <input
      [value]="consent.photoSubjectSub ?? consent.modelSub"
      id="modelSub"
      placeholder="Information saknas"
      readonly>
  </div>
  <div class="information-holder">
    <label for="time">TIDPUNKT:</label>
    <input
      [value]="consent.timeStamp | date: 'YYYY-MM-dd, HH:mm'"
      id="time"
      placeholder="Information saknas"
      readonly>
  </div>
  <div class="information-holder">
    <label for="modelEmail">EMAIL:</label>
    <input
      [value]="consent.modelEmail ?? null"
      id="modelEmail"
      placeholder="Information saknas"
      readonly>
  </div>
  <div class="information-holder">
    <label for="modelDescription">MODELLBESKRIVNING:</label>
    <input
      [value]="consent.modelDescription ?? null"
      id="modelDescription"
      placeholder="Information saknas"
      readonly>
  </div>
  @if (consent.kids && consent.kids.length > 0) {
    <div class="information-holder">
      <label for="modelKids">MINDERÅRIGS PERSONNUMMER:</label>
      <input
        id="modelKids"
        placeholder="Information saknas"
        [value]="consent.kids[0].pNr"
        readonly>
    </div>
    <div class="information-holder">
      <label for="modelKids">MINDERÅRIGS NAMN:</label>
      <input
        id="modelKids"
        placeholder="Information saknas"
        [value]="consent.kids[0].name"
        readonly>
    </div>
  }
  <div class="information-holder">
    <label for="photographer">SAMTYCKE INHÄMTAT AV:</label>
    <input
      [value]="(consent.photographerSub | slice:0:8) + '-' + (consent.photographerSub | slice:8)"
      id="photographer"
      placeholder="Information saknas"
      readonly>
  </div>
  <div class="information-holder">
    <label for="project">PROJEKT:</label>
    <input
      [value]="project?.name"
      id="project"
      placeholder="Information saknas"
      readonly>
  </div>
  <div class="information-holder">
    <label for="itemId">SIGNERINGS ID:</label>
    <input
      [value]="consent.itemId"
      id="itemId"
      placeholder="Information saknas"
      readonly>
  </div>
  @if (consent.photo) {
    <div class="image-holder">
      <img class="model-selfie" id="image" alt="Modell selfie"
           [src]="consent.photoUrl">
    </div>
  }

  <div class="consent-details-buttons-holder" matDialogActions>
    <button [mat-dialog-close]="null" class="foa-button" mat-flat-button>
      Stäng
    </button>
    <button (click)="openDialog(consent.itemId)" class="foa-button"
            mat-flat-button>
      Ta bort samtycke
    </button>
  </div>
</div>
